import * as THREE from 'three';
import type { IMapSurface, MapGeoPosition, MapHeightRevisionListener } from '../MapSurface';

export interface GlbMapSurfaceConfig {
    worldUnitsPerMeter: () => number;
    geoToWorld: (lat: number, lng: number, elevationMeters?: number) => THREE.Vector3 | null;
    worldToGeo: (world: THREE.Vector3) => MapGeoPosition | null;
    getWorldY: (x: number, z: number) => number | null;
    containsWorld: (x: number, z: number) => boolean;
    onHeightsChanged?: (listener: MapHeightRevisionListener) => () => void;
}

/** Adapter for a curated GLB map with a calibrated geo transform and BVH ground. */
export class GlbMapSurface implements IMapSurface {
    constructor(private readonly config: GlbMapSurfaceConfig) {}

    get worldUnitsPerMeter(): number {
        return this.config.worldUnitsPerMeter();
    }

    geoToWorld(lat: number, lng: number, elevationMeters?: number): THREE.Vector3 | null {
        return this.config.geoToWorld(lat, lng, elevationMeters);
    }

    worldToGeo(world: THREE.Vector3): MapGeoPosition | null {
        return this.config.worldToGeo(world);
    }

    getWorldY(x: number, z: number): number | null {
        return this.config.getWorldY(x, z);
    }

    containsWorld(x: number, z: number): boolean {
        return this.config.containsWorld(x, z);
    }

    onHeightsChanged(listener: MapHeightRevisionListener): () => void {
        return this.config.onHeightsChanged?.(listener) ?? (() => undefined);
    }
}
